import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes";
import { UsernameOptionTypes } from "../../common/types/UsernameOptionTypes";

export const getUserNameOptions = createAsyncThunk(
  "/user/get-username-options",
  async ( params: any, { rejectWithValue }) => {
    try {
      const method = "/user/get-username-options";
      const { data, errorMessage, isSuccess } = await commonNetwork.get(method);
      if (isSuccess) {
        data.sort((a: any, b: any) => b.userId - a.userId);
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (error: any) {
      return rejectWithValue(error.data.message);
    }
  }
)

export interface userNameOptionsStateType  extends FetchResultType{
    userNameOptions:UsernameOptionTypes
}
export const usernameOptionsSlice = createSlice({
  name: "usernameOptions",
  initialState: {
    userNameOptions: [],
    isfirmAvailable: true,
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
    isFetchComplete: false
  },
  reducers: {
    clearState: (state) => {
      state.userNameOptions = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.isFetchComplete = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserNameOptions.fulfilled, (state, { payload }) => {
      state.userNameOptions = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false; 
      state.isFetchComplete = true;
      return state;
    });
    builder.addCase(getUserNameOptions.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true; 
      // state.errorMessage = payload.message;
    });
    builder.addCase(getUserNameOptions.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = usernameOptionsSlice.actions;

export const usernameOptionsSelector = (state:any) => state.userNameOptions;

export const usernameOptionsReducer = usernameOptionsSlice.reducer;
